module.exports = __webpack_public_path__ + "img/p__宣武.b65007a6.png";